// limit all-at-once file importing (drag-and-drop)
export const MAX_IMPORT_FILES = 50;

// limit total number of files
export const MAX_TOTAL_FILES = 100;

// files should be no more than 1 MB
export const MAX_FILE_SIZE = 1048576;

// AI session logs are the one thing a candidate drops that legitimately exceeds
// 1 MB: the raw envelope carries the whole conversation plus every pasted image
// inlined as base64, and a single screenshot is ~270-670 KB once encoded.
//
// The ceiling is not arbitrary. Solution files are embedded in a single Mongo
// document and BSON caps a document at 16 MB, so an oversized drop does not just
// fail on its own -- it fails the whole solution's save. Revisions compound it:
// each stores a deflated copy of the file's contents, and base64 image data
// barely compresses. 10 MB is generous for a real session and still leaves the
// document clear of the ceiling.
//
// Deliberately narrow: every other dropped file stays at MAX_FILE_SIZE.
export const SESSION_LOG_MAX_FILE_SIZE = 10485760;

// Matches the raw session-log envelopes written by the session-log extractors,
// e.g. claude_session_log_raw_<session-id>.json. Every harness prefixes its raw
// file, so this never has to guess which one produced it.
export const SESSION_LOG_FILENAME =
  /^(claude|codex|copilot)_session_log_raw(_.*)?\.json$/i;
